module.exports = __webpack_public_path__ + "static/media/foodProcessing.79bb8287.png";